<template>
    <FormsCard>
    <router-link to="/auth" class="auth-back-link">
      <font-awesome-icon icon="fa-arrow-left"/>
      {{ $t('SuccessPasswordChangeComponent.backToLogin') }}
    </router-link>
    <img class="block mx-auto mb-6 w-32 sm:w-40 h-auto" src="@/assets/omind_logo.png" alt="test">
    <h2 class="text-center pb-5 text-xl sm:text-2xl">
        {{ $t('SuccessPasswordChangeComponent.passwordChangeSuccessMsg') }}</h2>
    <div class="text-[var(--color-orange)] text-6xl sm:text-9xl text-center mt-4">
        <font-awesome-icon icon="fa-circle-check"/>
    </div>
  </FormsCard>
</template>

<script>
import FormsCard from '../global/slots/FormsCard.vue';

export default {
  name: 'SuccessPasswordChangeComponent',
  components: {
    FormsCard,
  },
  unmounted() {
    this.$store.commit('setNewPasswordSetSuccesful', false);
  },
};
</script>
